<div class="lesson-tile-completion-container" [ngClass]="rootClassName">
  <div class="completion-title-row">
    <span class="completion-text headingboldsmall">
      <span>Performance</span>
    </span>
  </div>
  <div class="frame16pxspacer"></div>
  <div class="completion-stats-row">
    <div class="completion-stat-col lightbulb">
      <div class="completion-stat-icon-row lightbulb">
        <img
          src="/assets/icons/iconlightbulb.svg"
          alt="iconlightbulb"
          class="completion-icon"
        />
      </div>
      <div class="completion-stat-legend-row">
        <span class="completion-text bold">
          <span>{{retention}}</span>
        </span>
        <span class="completion-text dimmed small">
          <span>Retention</span>
        </span>
      </div>
    </div>
    <div class="completion-stat-col fire">
      <div class="completion-stat-icon-row fire">
        <img
          src="/assets/icons/iconfire.svg"
          alt="iconfire"
          class="completion-icon"
        />
      </div>
      <div class="completion-stat-legend-row">
        <span class="completion-text bold">
          <span>{{streak}}</span>
        </span>
        <span class="completion-text dimmed small">
          <span>Streak</span>
        </span>
      </div>
    </div>
    <div class="completion-stat-col circlecheck">
      <div class="completion-stat-icon-row circlecheck">
        <img
          src="/assets/icons/iconcirclecheckfill.svg"
          alt="iconcirclecheckfill"
          class="completion-icon"
        />
      </div>
      <div class="completion-stat-legend-row">
        <span class="completion-text bold">
          <span>{{completed}}</span>
        </span>
        <span class="completion-text dimmed small">
          <span>Completed</span>
        </span>
      </div>
    </div>
  </div>
</div>
